export const loginTestID = {
    button: 'authenticate-button',
    passwordToggle: 'password-login-toggle',
}
